<mat-spinner [diameter]="diameter" [strokeWidth]="stroke" color=""></mat-spinner>
